export default __webpack_public_path__ + "phone_tablet@2x.3e3e6f69.png";